<template>
    <layout>
        <div class="About-block">
            <div class="block-item block-item-1">
                <div class="block-item-1_block-content">
                    <div class="block-main-text">
                        {{ $t('aboutPage.heroPre') }}<span class="highlight">{{ $t('aboutPage.heroHl') }}</span>
                    </div>
                    <div class="block-sub-text">{{ $t('aboutPage.heroSub') }}</div>
                    <div class="block-tagline">{{ $t('aboutPage.heroTagline') }}</div>
                </div>
            </div>
            <div class="block-item block-item-2">
                <div class="about-content">
                    <!-- 左侧内容 -->
                    <div class="about-left">
                        <div class="company-title">
                            <div class="title-highlight">{{ $t('about.titleName') }}</div>
                            <div class="title-normal">{{ $t('about.gs') }}</div>
                        </div>
                        <div class="company-desc">
                            <p>{{ $t('aboutPage.coDesc') }}</p>
                        </div>
                        <div class="company-stats">
                            <div class="stat-item">
                                <div class="stat-number">2025</div>
                                <div class="stat-label">{{ $t('aboutPage.statFounded') }}</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">{{ $t('home.service.num2') }}</div>
                                <div class="stat-label">{{ $t('aboutPage.statScale') }}</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">100%</div>
                                <div class="stat-label">{{ $t('aboutPage.statAlgo') }}</div>
                            </div>
                        </div>
                    </div>
                    <!-- 右侧图片区域 -->
                    <div class="about-right">
                        <div class="about-image-wrapper">
                            <!-- 背景图片在这里添加 -->
                            <div class="about-image"></div>
                            <!-- 三个浮动标签按钮 -->
                            <div class="float-tag tag-purple">{{ $t('aboutPage.tag1') }}</div>
                            <div class="float-tag tag-yellow">{{ $t('aboutPage.tag2') }}</div>
                            <div class="float-tag tag-blue">{{ $t('aboutPage.tag3') }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block-item block-item-3">
                <div class="advantage-section">
                    <!-- 标题区域 -->
                    <div class="advantage-header">
                        <h2 class="advantage-title">{{ $t('aboutPage.advTitle') }}</h2>
                        <p class="advantage-subtitle">{{ $t('aboutPage.advSubtitle') }}</p>
                    </div>
                    <!-- 内容区域 -->
                    <div class="advantage-content">
                        <!-- 左侧 Tab 切换 -->
                        <div class="advantage-tabs">
                            <div class="tab-item" :class="{ active: activeTab === 0 }" @click="activeTab = 0">
                                <span class="tab-dot"></span>
                                <span class="tab-text">{{ $t('aboutPage.tab1') }}</span>
                            </div>
                            <div class="tab-item" :class="{ active: activeTab === 1 }" @click="activeTab = 1">
                                <span class="tab-dot"></span>
                                <span class="tab-text">{{ $t('aboutPage.tab2') }}</span>
                            </div>
                            <div class="tab-item" :class="{ active: activeTab === 2 }" @click="activeTab = 2">
                                <span class="tab-dot"></span>
                                <span class="tab-text">{{ $t('aboutPage.tab3') }}</span>
                            </div>
                        </div>
                        <!-- 右侧内容卡片 -->
                        <div class="advantage-cards">
                            <div class="cards-grid">
                                <!-- 左上卡片 -->
                                <div class="card-item card-left-top" :style="{ backgroundImage: 'url(' + require('@/assets/images/bg/矩形1777.png') + ')' }">
                                    <div class="card-overlay"></div>
                                    <div class="card-content">
                                        <!-- AI智能体 -->
                                        <template v-if="activeTab === 0">
                                            <p class="card-line"><span class="highlight-text">{{ $t('aboutPage.a1l1h') }}</span>{{ $t('aboutPage.a1l1r') }}</p>
                                        </template>
                                        <!-- 精干核心团队 -->
                                        <template v-else-if="activeTab === 1">
                                            <p class="card-line"><span class="highlight-text">{{ $t('aboutPage.a2l1h') }}</span>{{ $t('aboutPage.a2l1r') }}</p>
                                        </template>
                                        <!-- 严格的风险控制 -->
                                        <template v-else-if="activeTab === 2">
                                            <p class="card-line"><span class="highlight-text">{{ $t('aboutPage.a3l1h') }}</span>{{ $t('aboutPage.a3l1r') }}</p>
                                        </template>
                                    </div>
                                </div>
                                
                                <!-- 左下卡片 -->
                                <div class="card-item card-left-bottom" :style="{ backgroundImage: 'url(' + require('@/assets/images/bg/矩形1778.png') + ')' }">
                                    <div class="card-overlay"></div>
                                    <div class="card-content">
                                        <!-- AI智能体 -->
                                        <template v-if="activeTab === 0">
                                            <p class="card-line">{{ $t('aboutPage.a1l2r') }}<span class="highlight-text">{{ $t('aboutPage.a1l2h') }}</span></p>
                                        </template>
                                        <!-- 精干核心团队 -->
                                        <template v-else-if="activeTab === 1">
                                            <p class="card-line"><span class="highlight-text">{{ $t('aboutPage.a2l2h') }}</span>{{ $t('aboutPage.a2l2r') }}</p>
                                        </template>
                                        <!-- 严格的风险控制 -->
                                        <template v-else-if="activeTab === 2">
                                            <p class="card-line"><span class="highlight-text">{{ $t('aboutPage.a3l2h') }}</span>{{ $t('aboutPage.a3l2r') }}</p>
                                        </template>
                                    </div>
                                </div>
                                
                                <!-- 右侧大卡片 -->
                                <div class="card-item card-right" :style="{ backgroundImage: 'url(' + require('@/assets/images/bg/矩形1779.png') + ')' }">
                                    <div class="card-overlay"></div>
                                    <div class="card-content">
                                        <!-- AI智能体 -->
                                        <template v-if="activeTab === 0">
                                            <p class="card-line">{{ $t('aboutPage.a1l3r') }}<span class="highlight-number">30</span>{{ $t('aboutPage.a1l3m') }}</p>
                                            <p class="card-line">{{ $t('aboutPage.a1l3b') }}</p>
                                        </template>
                                        <!-- 精干核心团队 -->
                                        <template v-else-if="activeTab === 1">
                                            <p class="card-line">{{ $t('aboutPage.a2l3r') }}<span class="highlight-text">{{ $t('aboutPage.a2l3h') }}</span></p>
                                            <p class="card-line">{{ $t('aboutPage.a2l4') }}</p>
                                        </template>
                                        <!-- 严格的风险控制 -->
                                        <template v-else-if="activeTab === 2">
                                            <p class="card-line"><span class="highlight-text">{{ $t('aboutPage.a3l3h') }}</span>{{ $t('aboutPage.a3l3r') }}</p>
                                            <p class="card-line">{{ $t('aboutPage.a3l4') }}</p>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block-item block-item-4">
                <div class="vision-section">
                    <h2 class="vision-title">{{ $t('aboutPage.visionTitle') }}</h2>
                    <div class="vision-underline"></div>
                    <p class="vision-desc">{{ $t('aboutPage.visionDesc1') }}<br>{{ $t('aboutPage.visionDesc2') }}</p>
                </div>
            </div>
        </div>

        <share-modal />

        <report-modal />
    </layout>
</template>

<script>
import Pagination from '@/components/pagination/pagination'
import BlogCard from '@/components/blog/BlogCard1'
import Breadcrumb from '@/components/breadcrumb/Breadcrumb'
import Layout from '@/components/layouts/Layout'
import SalScrollAnimationMixin from '@/mixins/SalScrollAnimationMixin'
import BlogMixin from '@/mixins/BlogMixin'
import image1 from "@/assets/images/bg/icon_guanyuwomen_keji@3x.png"
import image2 from "@/assets/images/bg/icon_guanyuwomen_qukuailian@3x.png"
import image3 from "@/assets/images/bg/icon_guanyuwomen_lianghua@3x.png"
import image4 from "@/assets/images/bg/icon_guanyuwomen_guoji@3x.png"
import image5 from "@/assets/images/bg/icon_guanyuwomen_yinqing@3x.png"
import image6 from "@/assets/images/bg/icon_guanyuwomen_keji@3x (1).png"
import image7 from "@/assets/images/bg/icon_guanyuwomen_fengxian@3x.png"
import BlogPagination from "@/components/pagination/BlogPagination";
import BlogSidebar from "@/components/blog/BlogSidebar";

export default {
    name: 'BlogSingleColumn',
    components: { BlogSidebar, BlogPagination, Pagination, BlogCard, Breadcrumb, Layout },
    mixins: [SalScrollAnimationMixin, BlogMixin],
    data() {
        return {
            departments: [
                {
                    name: this.$t('about.Department.DepartmentName1'),
                    desc: this.$t('about.Department.DepartmentIntroduction1'),
                    icon: image1,
                    isActive: true
                },
                {
                    name: this.$t('about.Department.DepartmentName2'),
                    desc: this.$t('about.Department.DepartmentIntroduction2'),
                    icon: image2,
                    isActive: true
                },
                {
                    name: this.$t('about.Department.DepartmentName3'),
                    desc: this.$t('about.Department.DepartmentIntroduction3'),
                    icon: image3,
                    isActive: true
                },
                {
                    name: this.$t('about.Department.DepartmentName4'),
                    desc: this.$t('about.Department.DepartmentIntroduction4'),
                    icon: image4,
                    isActive: true
                },
            ],
            choice: [
                {
                    name: this.$t('about.prospect.prospectName1'),
                    desc: this.$t('about.prospect.prospectHome1'),
                    icon: image5,
                    isActive: true
                },
                {
                    name: this.$t('about.prospect.prospectName2'),
                    desc: this.$t('about.prospect.prospectHome2'),
                    icon: image6,
                    isActive: true
                },
                {
                    name: this.$t('about.prospect.prospectName3'),
                    desc: this.$t('about.prospect.prospectHome3'),
                    icon: image7,
                    isActive: true
                },
            ],
            pageStart: '',
            countOfPage: '',
            activeTab: 0
        }
    },
    methods: {
        paginatedData(filteredRows, pageStart, countOfPage) {
            this.filteredRows = filteredRows;
            this.pageStart = pageStart;
            this.countOfPage = countOfPage;
        }
    }
}
</script>

<style scoped lang="scss">
.About-block {
    width: 100%;
    background-image: url("~@/assets/images/bg/appbg.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.block-item-1 {
    background-image: url("~@/assets/images/bg/bg_aboutItem_1.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.block-item-1_block-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 20px;
    margin-bottom: 50px;
}

.block-main-text {
    font-size: 78px;
    font-weight: 700;
    color: #FFFFFF;
    line-height: 1.3;
    margin-bottom: 8px;
    text-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
}

.block-main-text .highlight {
    color: #FFD200;
}

.block-sub-text {
    font-size: 78px;
    font-weight: 700;
    color: #FFFFFF;
    line-height: 1.3;
    margin-bottom: 16px;
    text-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
}

.block-tagline {
    font-size: 28px;
    color: #FFD200;
    letter-spacing: 4px;
    margin-top: 40px;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

/* ========== block-item-1 响应式 ========== */
@media (max-width: 768px) {
    .block-main-text {
        font-size: 32px;
    }

    .block-sub-text {
        font-size: 32px;
    }

    .block-tagline {
        font-size: 15px;
        letter-spacing: 2px;
    }
}

@media (max-width: 480px) {
    .block-main-text {
        font-size: 24px;
    }

    .block-sub-text {
        font-size: 24px;
    }

    .block-tagline {
        font-size: 13px;
        letter-spacing: 1px;
        margin-top: 20px;
    }
}

/* ========== block-item-2 关于我们区块 ========== */
.block-item-2 {
    /* 背景图片在这里添加 */
     background-image: url("~@/assets/images/bg/Ellipse 436.png"); 
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    min-height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    // padding: 80px 0;
}

.about-content {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 60px;
}

.about-left {
    flex: 1;
    max-width: 600px;
}

.company-title {
    font-size: 42px;
    font-weight: 700;
    margin-bottom: 30px;
    line-height: 1.4;
}

.title-highlight {
    color: #FFD200;
    font-size: 48px;
}

.title-normal {
    color: #FFFFFF;
     font-size: 48px;
}

.company-desc {
    margin-bottom: 50px;
}

.company-desc p {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.85);
    line-height: 1.8;
}

.company-stats {
    display: flex;
    gap: 50px;
}

.stat-item {
    text-align: left;
}

.stat-number {
    font-size: 40px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 8px;
}

.stat-label {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
}

.about-right {
    flex: 1;
    max-width: 550px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.about-image-wrapper {
    position: relative;
    width: 100%;
    height: 800px;
    /* 背景图片在这里添加 */
    background-image: url("~@/assets/images/bg/Ellipse 436.png"); 
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}

.about-image {
    width: 100%;
    height: 100%;
    /* 背景图片在这里添加 */
     background-image: url("~@/assets/images/bg/aboutItem_2_img.png"); 
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}

/* 浮动标签按钮 */
.float-tag {
    position: absolute;
    padding: 10px 24px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    white-space: nowrap;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.tag-purple {
    background: linear-gradient(107deg, #c996fa 15%, #962de7 84%);
    top: 40%;
    left: -20px;
}

.tag-yellow {
    background: linear-gradient(90deg, #ffe152 0%, #ffbb1c 100%);
    bottom: 30%;
    right: -20px;
    // color: #333;
}

.tag-blue {
    background: linear-gradient(107deg, #91a2fa 15%, #3e51d9 84%);
    top: 21%;
    right: -20px;
}

/* ========== block-item-2 响应式 ========== */
@media (max-width: 1024px) {
    .about-content {
        flex-direction: column;
        padding: 0 40px;
        gap: 40px;
    }

    .about-left,
    .about-right {
        max-width: 100%;
    }

    .company-title {
        font-size: 32px;
    }

    .stat-number {
        font-size: 28px;
    }

    .company-stats {
        gap: 30px;
    }
}

@media (max-width: 768px) {
    .block-item-2 {
        padding: 60px 0;
    }

    .about-content {
        padding: 0 20px;
    }

    .company-title {
        font-size: 24px;
    }

    .company-desc p {
        font-size: 14px;
    }

    .stat-number {
        font-size: 24px;
    }

    .stat-label {
        font-size: 12px;
    }

    .company-stats {
        gap: 20px;
        flex-wrap: wrap;
    }

    .about-image-wrapper {
        height: 300px;
    }

    .float-tag {
        padding: 6px 14px;
        font-size: 12px;
        border-radius: 15px;
    }

    .tag-purple {
        left: 0;
        top: 25%;
    }

    .tag-yellow {
        right: 0;
        bottom: 20%;
    }

    .tag-blue {
        right: 5%;
        top: 5%;
    }
}

/* ========== block-item-3 衍泰的优势 ========== */
.block-item-3 {
    min-height: 50vh;
    width: 100%;
    // padding: 100px 0;
    /* 背景图片在这里添加 */
    /* background-image: url("~@/assets/images/bg/xxx.png"); */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.advantage-section {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 60px;
}

.advantage-header {
    text-align: center;
    margin-bottom: 80px;
}

.advantage-title {
    font-size: 42px;
    font-weight: 700;
    color: #FFFFFF;
    margin-bottom: 20px;
}

.advantage-subtitle {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 1.6;
    max-width: 800px;
    margin: 0 auto;
}

.advantage-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 80px;
}

/* 左侧 Tab */
.advantage-tabs {
    flex: 0 0 300px;
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.tab-item {
    display: flex;
    align-items: center;
    gap: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 10px 0;
}

.tab-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.3);
    transition: all 0.3s ease;
}

.tab-text {
    font-size: 32px;
    color: rgba(255, 255, 255, 0.5);
    transition: all 0.3s ease;
}

.tab-item.active .tab-dot {
    background: #9b6dff;
    box-shadow: 0 0 10px rgba(155, 109, 255, 0.5);
}

.tab-item.active .tab-text {
    color: #FFFFFF;
    font-weight: 600;
}

.tab-item:hover .tab-text {
    color: rgba(255, 255, 255, 0.8);
}

/* 右侧卡片 */
.advantage-cards {
    flex: 1;
}

.cards-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 20px;
    height: 400px;
}

.card-item {
    position: relative;
    border-radius: 16px;
    padding: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-position: center;
    border: 1px solid #86909C;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.4s ease;
}

/* 鼠标悬停时边框变白并添加白色阴影 */
.card-item:hover {
    border-color: #fff;
    box-shadow: 0 0 40px rgba(255, 255, 255, 0.5);
}

/* 半透明蒙层 */
.card-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(20, 20, 50, 0.75);
    transition: opacity 0.4s ease;
    z-index: 1;
}

/* 卡片内容 */
.card-content {
    position: relative;
    z-index: 2;
    text-align: center;
    transition: opacity 0.4s ease;
}

/* 鼠标悬停时蒙层和文字消失 */
.card-item:hover .card-overlay {
    opacity: 0;
}

.card-item:hover .card-content {
    opacity: 0;
}

.card-left-top {
    grid-column: 1;
    grid-row: 1;
}

.card-left-bottom {
    grid-column: 1;
    grid-row: 2;
}

.card-right {
    grid-column: 2;
    grid-row: 1 / 3;
    flex-direction: column;
}

.card-content p {
    margin: 0;
    line-height: 1.6;
}

.card-content .card-line {
    color: #FFFFFF;
    font-size: 18px;
    margin: 4px 0;
    line-height: 1.5;
}

.card-content .highlight-text {
    color: #FFD200;
    font-size: 20px;
    font-weight: 600;
}

.card-content .highlight-number {
    color: #FFD200;
    font-size: 32px;
    font-weight: 700;
}

/* ========== block-item-3 响应式 ========== */
@media (max-width: 1024px) {
    .advantage-content {
        flex-direction: column;
        gap: 50px;
    }

    .advantage-tabs {
        flex: none;
        width: 100%;
        flex-direction: row;
        justify-content: center;
        gap: 40px;
    }

    .tab-text {
        font-size: 18px;
    }

    .cards-grid {
        height: 350px;
    }
}

@media (max-width: 768px) {
    .block-item-3 {
        padding: 60px 0;
    }

    .advantage-section {
        padding: 0 20px;
    }

    .advantage-title {
        font-size: 28px;
    }

    .advantage-subtitle {
        font-size: 14px;
    }

    .advantage-tabs {
        flex-direction: column;
        gap: 20px;
    }

    .tab-item {
        justify-content: center;
    }

    .cards-grid {
        grid-template-columns: 1fr;
        grid-template-rows: auto;
        height: auto;
    }

    .card-right {
        grid-column: 1;
        grid-row: auto;
        min-height: 150px;
    }

    .card-left-top,
    .card-left-bottom {
        min-height: 100px;
    }
}

/* ========== block-item-4 公司愿景 ========== */
.block-item-4 {
    min-height: 60vh;
    width: 100%;
    // padding: 100px 0;
    background-image: url("~@/assets/images/bg/gsyjbg.png");
    background-size: 900px auto;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
}

.vision-section {
    text-align: center;
    max-width: 800px;
    padding: 0 20px;
}

.vision-title {
    font-size: 48px;
    font-weight: 700;
    color: #FFFFFF;
    margin-bottom: 16px;
}

.vision-underline {
    width: 420px;
    height: 40px;
    background-image: url("~@/assets/images/bg/Vector 2.png");
    background-size: 200px auto;
    background-repeat: no-repeat;
    background-position: center;
    margin: 0 auto 30px;
}

.vision-desc {
    font-size: 34px;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.8;
}

/* ========== block-item-4 响应式 ========== */
@media (max-width: 768px) {
    .block-item-4 {
        padding: 60px 0;
        min-height: 50vh;
    }

    .vision-title {
        font-size: 28px;
    }

    .vision-desc {
        font-size: 16px;
    }
}
</style>